import {FAQItem} from 'attendee/Help/FAQ'
import React, {ReactElement, useMemo} from 'react'
import {useI18n} from 'i18n/I18nContext'
import {getEventFaqEntry} from './eventFaqData'
import {EVENT_FAQ_ORDER, type EventFaqKey} from './eventFaqKeys'

export {
  EVENT_FAQ_ORDER as FAQ_ORDER,
  type EventFaqKey as FAQKey,
} from './eventFaqKeys'

export {EventFaqHelp} from './EventFaqHelp'

type FAQItemData = {
  question: string
  answer: ReactElement
}

export function useEventFaqItems(): Record<EventFaqKey, FAQItemData> {
  const {locale} = useI18n()
  return useMemo(() => {
    const out = {} as Record<EventFaqKey, FAQItemData>
    for (const key of EVENT_FAQ_ORDER) {
      const {q, a} = getEventFaqEntry(locale, key)
      out[key] = {
        question: q,
        answer: (
          <div style={{whiteSpace: 'pre-line'}} className="event-faq-answer">
            {a}
          </div>
        ),
      }
    }
    return out
  }, [locale])
}

export function FAQ(): JSX.Element {
  const items = useEventFaqItems()
  return (
    <div className="accordion" id="accordionFAQ">
      {EVENT_FAQ_ORDER.map((key, index) => {
        const item = items[key]
        return (
          <FAQItem
            key={key}
            open={index === 0}
            question={item.question}
            answer={item.answer}
          />
        )
      })}
    </div>
  )
}
